/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ProgrammingLanguageOptions {
  TYPESCRIPT = 'typescript',
  JAVASCRIPT = 'javascript',
  CPP = 'cpp',
  JAVA = 'java',
  PHP = 'php',
  PYTHON = 'python',
  HTML = 'html',
  SQL = 'sql',
  JSON = 'json',
  RUST = 'rust',
  XML = 'xml',
  CLOJURE = 'clojure',
  CSHARP = 'csharp',
  CSS = 'css',
  SCSS = 'scss',
  OTHER = 'other',
}
